module.exports = __webpack_public_path__ + "media/src/images/icons/pencil/red-8f41cfa52ef682dcaf7aed61445707c7.svg";